import { render, staticRenderFns } from "./My.vue?vue&type=template&id=00231b17&scoped=true"
import script from "./My.vue?vue&type=script&lang=js"
export * from "./My.vue?vue&type=script&lang=js"
import style0 from "../assets/css/common.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "../assets/css/index_my.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./My.vue?vue&type=style&index=2&id=00231b17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00231b17",
  null
  
)

export default component.exports